import React, { forwardRef,  useImperativeHandle,useState, useEffect} from "react";
import { useTranslation } from 'react-i18next';
import { Menu, MenuItem, MenuButton } from '@szhsin/react-menu';
import useStore from "../../../hooks/useStore";
import { toast } from 'react-toastify';
import ApiClient from "../../../services/api-client"
import { useNavigate } from 'react-router-dom'
import { CustomConfirmAlert as confirmAlert } from '../../../components/custom-confirm-alert';


const SeriesNumberRendener = forwardRef((props, ref) => {
    const [seriesNumber, setSeriesNumber] = useState(props.value);
    const [canceledIcon, setCanceledIcon] = useState("");
    const [seriesElement, setSeriesElement] = useState("");
    const { t } = useTranslation();
    const [actionElement, setActionElement] = useState(<span></span>);
    const navigate = useNavigate();


    useImperativeHandle(ref, () => {
        return {
            refresh(params) {
                var val = props.getValue();


                if (val) {
                    setSeriesNumber(val);
                }
            }
        };

    });

    const handleInputChange = (e) => {
        // e.preventDefault();
        var _data = props.data;
        ApiClient.getTemplateSettings(_data.company.id, _data.branchId).then(response => {
            var _template = response.data;
            var _temp = {
                branch: _data.branchId,
                template: _template.template,
                mainColor: _template.mainColor,
                secondaryColor: _template.secondaryColor,
                appFont: _template.appFont,
                css: _template.css,
                logo: _template.logo,
                iban: _template.iban
            }

            props.colDef.cellRendererParams.setTemplate(_template);
            var saleInstance = props.colDef.cellRendererParams.getPrintSale(_data);
            saleInstance.LOGO = _temp.logo;
            saleInstance.IBAN = _temp.iban;
            console.log(saleInstance)
            props.colDef.cellRendererParams.onClickPrint(saleInstance)

        },
            error => {
                console.error(
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString())
            }
        );

    }

    const handleCancel = (e) => {
        // e.preventDefault();
        var id = props.data.id;
        var companyId = useStore.getState().selectedCompany.id;

        var mess = props.data.mark ? t("cancelationConfirm0") + " " + t("cancelationConfirm1") : t("cancelationConfirm0");

        confirmAlert({
            title: t("submitConfirm"),
            message: mess,
            submessage: t("cancelationConfirm2"),
            buttons: [
                {
                    label: t('Yes'),
                    onClick: () => {
                        var rowNode = props.node;
                        const seriesNumber = props.data.seriesNumber;
                        props.colDef.cellRendererParams.blockUi(true)
                        ApiClient.cancelMyDataInvoice(companyId, id).then(
                            response => {

                                if (response.data.response[0].statusCode == "Success") {
                                    var cancelMark = response.data.response[0].cancellationMark;


                                    var mark = rowNode.data.mark;
                                    if (cancelMark) {
                                        var _htm = <span className="canceled-series-span"><span>{seriesNumber}</span></span>;
                                        rowNode.setDataValue("seriesNumber", _htm);
                                        rowNode.setDataValue("cancelationMark", cancelMark);
                                        // var cm=<span className="mark-span-container"><span className="cancelationMark-span">{cancelMark}</span><span className="mark-span">{mark}</span>  </span>
                                        rowNode.setDataValue("mark", mark);

                                        const actionel = <div>
                                            <Menu menuButton={<MenuButton><span style={{ color: 'black' }}><i className="fa fa-bars"></i></span></MenuButton>} transition>
                                                <MenuItem onClick={handleInputChange} ><i className="fa fa-print"></i>Print</MenuItem>
                                                <MenuItem onClick={hangleEdit} ><i className="fa fa-edit"></i>Edit</MenuItem>
                                                <MenuItem onClick={showEmailModal} ><i className="fa fa-envelope"></i>Send Email</MenuItem>
                                                <MenuItem onClick={goToPublic} ><i className="fa fa-eye"></i>View</MenuItem>
                                            </Menu>

                                        </div>
                                        setActionElement(actionel)
                                        // rowNode.gridApi.redrawRows()
                                        props.api.refreshInfiniteCache()
                                    }
                                    else {
                                        props.api.refreshInfiniteCache()
                                    }

                                    if (cancelMark) {
                                        toast.success(t("invoiceCanceled", { mark: cancelMark }), { autoClose: 5000 })
                                    }
                                    else {
                                        toast.success(t("invoiceCanceledNoCancelMark"), { autoClose: 5000 })
                                    }


                                }
                                else {
                                    var errors = response.data.response[0].errors.error;
                                    errors.forEach(e => {
                                        toast.error(e.message, { autoClose: 5000 })
                                    })
                                }

                                props.colDef.cellRendererParams.blockUi(false)

                            },
                            error => {
                                console.error(
                                    (error.response &&
                                        error.response.data &&
                                        error.response.data.message) ||
                                    error.message ||
                                    error.toString())
                                props.colDef.cellRendererParams.blockUi(false)
                            }
                        );
                    }
                },
                {
                    label: t('No'),
                    onClick: () => {
                    }
                }
            ]
        });



    }

    const showEmailModal = () => {
        var companyId = useStore.getState().selectedCompany.id;
        ApiClient.findCompanyCustomerContacts(companyId, props.data.customerTaxPayerId, props.data.customerName).then(
            response => {
                var contacts = response.data;
                var _contacts = []
                contacts.forEach(e => {
                    _contacts.push({
                        value: e.email,
                        name: e.name,
                        email: e.email,
                        label: e.email
                    })
                });


                var columns = [
                    {
                        header: t("Name"),
                        field: "name",
                        flex: 6,
                    },
                    {
                        header: t("Email"),
                        field: "email",
                        flex: 6,
                        asLabel: true

                    }
                ]



                var _company = useStore.getState().selectedCompany;
                if (_company.accountantEmail) {
                    _contacts.push({
                        value: _company.accountantEmail,
                        name: t("companyAccountant"),
                        email: _company.accountantEmail,
                        label: _company.accountantEmail
                    })
                }

                var opts = { data: _contacts, columns: columns };

                props.colDef.cellRendererParams.setShowEmailModal(true);
                props.colDef.cellRendererParams.setCustomerContacts(opts);
                props.colDef.cellRendererParams.setLineData(props.data);

            },
            error => {
                console.log(
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString())
            }
        );
    }




    const goToPublic = () => {
        var invoiceUid = props.data.invoiceUid;
        window.open("/mydata/" + invoiceUid, "_blank");
    }
    const hangleEdit = () => {
        navigate("/sale/" + props.data.id);
    }
    const publishCredit = () => {
        navigate("/sale/" + props.data.id + "?credit=true");
    }
    useEffect(() => {


        if (props.node.data != null) {
            if (props.node.data.canceled) {
                setSeriesElement(<span className="seriesNumber canceled-series-symbol"><span>{props.node.data.seriesNumber}</span></span>)
            }
            else {
                setSeriesElement(<span className="seriesNumber"><span>{props.node.data.seriesNumber}</span></span>)
            }
        }
    }, [props.node])
    const cancelMenu = props.node.data ? (!props.node.data.canceled ?
        <MenuItem onClick={handleCancel}>
            <i className="fa fa-times"></i>{t("cancelInvoiceMenu")}
        </MenuItem>
        : "") : ""




    const publishMenu = props.node.data ? (props.node.data.myDataInvoiceType == "invoice1_1" || props.node.data.myDataInvoiceType == "invoice2_1" ?
        <MenuItem onClick={publishCredit} ><i className="fa fa-credit-card"></i>{t("creditInvoiceMenu")}</MenuItem>
        : "") : ""
    return (

        <span>

            <Menu transition menuButton={
                <MenuButton>
                    <span style={{ color: 'black' }}>{seriesElement}</span>
                </MenuButton>} >
                <MenuItem onClick={handleInputChange} ><i className="fa fa-print"></i>{t("printMenu")}</MenuItem>
                <MenuItem onClick={hangleEdit} ><i className="fa fa-edit"></i>{t("editMenu")}</MenuItem>
                <MenuItem onClick={showEmailModal} ><i className="fa fa-envelope"></i>{t("sendEmailMenu")}</MenuItem>
                <MenuItem onClick={goToPublic} ><i className="fa fa-eye"></i>{t("viewInvoiceMenu")}</MenuItem>
                {publishMenu}
                {cancelMenu}
            </Menu>
        </span>
    );
});




export default SeriesNumberRendener;